module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAALlJREFUKBWNkjEOwjAMRb+NmBBi5gzcAnEMtkJ34ByFHcHGMVBvwRmYAXVCNPhDsjSB1ouVnxc78Y/Ah3OQxxYLy5kDJpQFuIjgOFzjYNnkjwZUO4yfL5xMmlKMQlD2e5gPVrgqK/+FedoKkSEr9wLLusY+qpoQVJGzQ5bYS0pkNTwwSTREstrQWpfK0bVSHiCrnHPnA8YKR3UrcP7pQahmXow2mLGDoylmaxn2ouyNI2vX+gY7dfkaby6cQ/e2sNojAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/last.png
// module id = LsoG
// module chunks = 81